// extracted by mini-css-extract-plugin
var _1 = "j2TCg";
var _2 = "RxV7G";
var _3 = "CarkW";
var _4 = "o6yPg";
export { _1 as "addFavoriteContainer", _2 as "starIcon", _3 as "starIconFull", _4 as "starIconMedium" }
